export default "__VITE_ASSET__76ad86d6__"